import {
  Login,
  ChangePassword,
  ForgotPassword,
  LatestNews,
  NewsMedia,
  AddEditNewsMedia,
  StrategicInvestment,
  JobPosting,
  AddEditJobPosting,
  AnnualReporting,
  AddEditAnnualReporting,
  InvestorInfoMBAPL,
  AddEditInvestorInfoMBAPL,
  InvestorInfoKPL,
  AddEditInvestorInfoKPL,
} from "@/pages";
import MainFinancialReporting from "@/pages/Admin/FinancialReporting/MainFinancialReporting";
import { Navigate, useRoutes } from "react-router-dom";
import { routes } from "./utils";
import { Layout, NotFound } from "@/components";
import ProtectedRoute from "./ProtectedRoute";

export const Router = () => {
  const element = useRoutes([
    {
      path: routes.root,
      element: <Login />,
    },
    {
      path: routes.login,
      element: <Login />,
    },
    {
      path: routes.changePassword,
      element: <ChangePassword />,
    },
    {
      path: routes.forgotPassword,
      element: <ForgotPassword />,
    },
    {
      // Only admins allowed
      path: routes.admin,
      element: <ProtectedRoute />,
      children: [
        {
          path: "",
          element: <Layout />,
          children: [
            {
              path: "",
              element: (
                <Navigate to={`/${routes.admin}/${routes.latestNews}`} />
              ),
            },
            {
              path: routes.latestNews,
              element: <LatestNews />,
            },
            {
              path: routes.strategicInvestment,
              element: <StrategicInvestment />,
            },
            {
              path: routes.financialReporting,
              element: <MainFinancialReporting />,
            },
            {
              path: routes.newsMedia,
              element: <NewsMedia />,
              children: [
                {
                  path: `${routes.action}`,
                  element: <AddEditNewsMedia />,
                },
                {
                  path: `${routes.id}/${routes.action}`,
                  element: <AddEditNewsMedia />,
                },
              ],
            },
            {
              path: routes.annualReporting,
              element: <AnnualReporting />,
              children: [
                {
                  path: `${routes.action}`,
                  element: <AddEditAnnualReporting />,
                },
                {
                  path: `${routes.id}/${routes.action}`,
                  element: <AddEditAnnualReporting />,
                },
              ],
            },
            {
              path: routes.jobPosting,
              element: <JobPosting />,
              children: [
                {
                  path: `${routes.action}`,
                  element: <AddEditJobPosting />,
                },
                {
                  path: `${routes.id}/${routes.action}`,
                  element: <AddEditJobPosting />,
                },
              ],
            },
            {
              path: routes.investorInfoMBAPL,
              element: <InvestorInfoMBAPL />,
              children: [
                {
                  path: `${routes.action}`,
                  element: <AddEditInvestorInfoMBAPL />,
                },
                {
                  path: `${routes.id}/${routes.action}`,
                  element: <AddEditInvestorInfoMBAPL />,
                },
              ],
            },
            {
              path: routes.investorInfoKPL,
              element: <InvestorInfoKPL />,
              children: [
                {
                  path: `${routes.action}`,
                  element: <AddEditInvestorInfoKPL />,
                },
                {
                  path: `${routes.id}/${routes.action}`,
                  element: <AddEditInvestorInfoKPL />,
                },
              ],
            },
          ],
        },
      ],
    },
    {
      path: "*",
      element: <NotFound />,
    },
  ]);

  return element;
};
